import low_dash from '@/utils/convert-to-low-dash'

export default {
  methods: {
    getOptionList(list, idField, valueField, textField, stateProp = null) {
      let optionList = list.map(option => {
        let optionObj = {}
        optionObj['id'] = option[idField]
        optionObj['value'] = option[valueField]
        optionObj['text'] = option[low_dash(textField)]
        if (option.pk === stateProp) {
          optionObj['selected'] = true
        }
        return optionObj
      })
      return optionList
    },

    formatValue(value) {
      if (value !== '' && !isNaN(value)) {
        return parseInt(value)
      }
      return value
    },
  },
}
